import type { Difficulty } from "../types";
import { hagenBgbAt } from "./mc-variants/hagen-bgb-at";
import { hagenRest } from "./mc-variants/hagen-rest";
import { patg1 } from "./mc-variants/patg1";
import { patg2 } from "./mc-variants/patg2";

export interface McVariant {
  correctTexts: string[];
  distractorsByDifficulty: Partial<Record<Difficulty, string[]>>;
}

// Adaptive Distraktor-Varianten fuer MC-Bestandsfragen (Frage-id -> Varianten).
// Wird vom Anreicherungs-Schwarm (B4-5) modulweise befuellt (eigene Dateien in mc-variants/)
// und ist question-reviewer-geprueft. mapRawExercise haengt vorhandene Eintraege per id an,
// danach rendert PracticePanel die Frage adaptiv (4 Stufen). Fragen ohne Eintrag bleiben statisch.
export const mcVariants: Record<string, McVariant> = {
  ...hagenBgbAt,
  ...hagenRest,
  ...patg1,
  ...patg2,
};
